import React, { useState, useEffect, useRef } from "react";
import "./ProductSelect.scss";
import Button from "../components/ui/Button";
import { addToCart, openCart, toggleSubscription } from "../store/cartSlice";
import PetTypeSelector from "../components/product/PetTypeSelector";
import { useAppNavigate } from "../hooks/useAppNavigate";
import { Oval } from 'react-loader-spinner';
import { useAffiliate } from "../hooks/useAffiliate";
import { useGetProductBundlesQuery, useGetProductsQuery } from "../store/apiSlice";
import { trackCTA } from "../utils/trackCTA";
import BundleBox from "../components/product/BundleBox";
import packages from '/images/packages.png';
import Heading from "../components/ui/Heading";
import pet_icon1 from '/icons/why-us-icon-1.svg';
import pet_icon2 from '/icons/why-us-icon-2.svg';
import pet_icon3 from '/icons/why-us-icon-3.svg';


const BundlesPage = () => {
  const navigate = useAppNavigate();
  const { affiliate, isLoading: isLoadingAffiliate } = useAffiliate();
  const { data: bundles, isLoading: bundlesLoading } = useGetProductBundlesQuery();
  const [selectedPetType, setSelectedPetType] = useState(() => localStorage.getItem("petType") || "dog");

  // Filters
  const filteredBundles = (bundles || [])
    .filter((bundle) => bundle.petType?.toLowerCase() === selectedPetType?.toLowerCase());


  if (bundlesLoading) {
    return (
      <div className="flex justify-center items-center w-full h-screen min-h-screen">
        <Oval
          visible={true}
          height={50}
          width={50}
          color="#a99cdf"
          strokeWidth="3"
          strokeWidthSecondary="3"
          secondaryColor="#e2e6ff"
          ariaLabel="oval-loading"
        />
      </div>
    );
  }

  return (
    <>
      <div className='landing-page'>
        <div className='home-hero full-width'>
          <div className='flex-container contained-width pb-[200px] md:pb-[100px]'>
            <div className={`flex flex-col gap-3 ${!affiliate ? 'md:gap-5' : ''} mt-0 md:mt-0`}>
              {affiliate && (
                <div className='affiliate-logo-cont flex w-full justify-start md:mt-0'>
                  <img
                    src={affiliate.logo}
                    alt={`${affiliate.name} logo`}
                    className='affiliate-logo'
                  />
                </div>
              )}
              <h1>Save with<br />Bundles!</h1>
              <p className='text-mid mb-8'>
                Get personalized, vet-approved treats with your pet featured on the label.
              </p>
              <Button
                type="button"
                variant="filled"
                style={{ maxWidth: 'fit-content' }}
                onClick={() => {
                  navigate('/customizer');
                }}
              >
                Start Personalizing
              </Button>

            </div>
            <div className='flex items-center justify-end'>
              <img src={packages} alt="" className="w-full max-w-none md:max-w-[500px]" />
            </div>
          </div>
        </div>
      </div>

      <section className="product-select customizer-page full-width flex flex-col gap-10 items-center mt-[-100px] md:mt-[-150px]">
        <div className="contained-width flex flex-col gap-5">
          <div className={`flex justify-center items-center w-full gap-6 flex-col relative`}>
            <h2 className={`text-center md:text-right capitalize color-swap ${(affiliate && !affiliate?.auto_discount) ? 'affiliate-margin' : ''}`}>Bundles for {selectedPetType}s</h2>
            <div className="flex gap-3 flex-col md:flex-row items-center">
              <PetTypeSelector
                selected={selectedPetType}
                setSelected={setSelectedPetType}
              />
            </div>
          </div>
        </div>
        <div className={`product-boxes flex flex-wrap justify-center gap-[20px] w-full`}>
          {!bundlesLoading && filteredBundles.length > 0 ? (
            filteredBundles.map((bundle) => (
              <BundleBox
                key={bundle.id}
                bundle={bundle}
                products={bundle.products}
                finalImages={{}}
                toggleSubscription={toggleSubscription}
                className="w-[100%] sm:w-[calc(50%-10px)] md:w-[calc(33.33%-15px)]"
              />
            )))
            :
            <p className="text-gray-500 text-center col-span-full color-swap">No bundles found.</p>
          }
        </div>
      </section>

      <section className="why-us-container full-width flex justify-center" id="benefits">
        <div className="contained-width flex flex-col gap-10">
          <Heading
            h4Text="Our Benefits"
            h2Text="Why Pet Parents Love Treatink"
            h4Size="small"
            h2Size="small"
            align="center"
            h4Color="secondary"
          />
          <div className="why-us-boxes grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 gap-5">
            <div className="rounded-20 p-4 box-shadow py-8 gap-8 flex flex-col items-center">
              <div className="flex flex-col justiy-center items-center gap-4 md:gap-8">
                <img src={pet_icon1} alt="" />
                <h4 className="form-title body-heading">Personalized Treats</h4>
                <p className="text-center">Add your pet’s photo to their favorite veterinary recommended treats, supplements, and more.</p>
              </div>
              <Button type="button" variant="outlined" onClick={() => {
                navigate('/customizer');
                trackCTA('Try Now');
              }}
                style={{ maxWidth: 'fit-content' }}
              >
                Try Now
              </Button>
            </div>
            <div className="rounded-20 p-4 box-shadow py-8 gap-8 flex flex-col items-center">
              <div className="flex flex-col justiy-center items-center gap-4 md:gap-8">
                <img src={pet_icon2} alt="" />
                <h4 className="form-title body-heading">Unique & Fun Gifts</h4>
                <p className="text-center">Perfect for pet lovers and special moments.</p>
              </div>
              <Button type="button" variant="outlined" onClick={() => {
                navigate('/customizer');
                trackCTA('Try Now');
              }}
                style={{ maxWidth: 'fit-content' }}
              >
                Try Now
              </Button>
            </div>
            <div className="rounded-20 p-4 box-shadow py-8 gap-8 flex flex-col items-center">
              <div className="flex flex-col justiy-center items-center gap-4 md:gap-8">
                <img src={pet_icon3} alt="" />
                <h4 className="form-title body-heading">Easy Customization</h4>
                <p className="text-center">Create in just a few clicks - no design skills needed!</p>
              </div>
              <Button type="button" variant="outlined" onClick={() => {
                navigate('/customizer');
                trackCTA('Try Now');
              }}
                style={{ maxWidth: 'fit-content' }}
              >
                Try Now
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BundlesPage;
